/* Mon Horloge Murale — cadrans de l'atelier (2026-10-30). Pose l'heure réelle au chargement ; ensuite tout tourne en CSS
   (balayage continu ou saccade d'une seconde). Aucune boucle JS, rien quand prefers-reduced-motion. */
(function () {
  function poser(el) {
    if (el.dataset.ok) return; el.dataset.ok = '1';
    var d = new Date(), s = d.getSeconds() + d.getMilliseconds() / 1000, m = d.getMinutes() + s / 60, h = (d.getHours() % 12) + m / 60;
    el.style.setProperty('--d-s', (-s) + 's');
    el.style.setProperty('--d-m', (-m * 60) + 's');
    el.style.setProperty('--d-h', (-h * 3600) + 's');
    var hh = el.querySelector('[data-hm-hh]'), mm = el.querySelector('[data-hm-mm]');
    if (hh) { hh.textContent = String(d.getHours()).padStart(2, '0'); mm.textContent = String(d.getMinutes()).padStart(2, '0'); }
  }
  function tout() { document.querySelectorAll('[data-hm-cadran]').forEach(poser); }
  if (document.readyState !== 'loading') tout(); else document.addEventListener('DOMContentLoaded', tout);
  document.addEventListener('shopify:section:load', tout);
})();
